import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import {useSubscription} from 'react-stomp-hooks';

import './index.style.less';
import {IoIosNotificationsOutline} from 'react-icons/io';
import {Button, Dropdown, List, Menu, message, notification} from 'antd';
import AppScrollbar from '../AppScrollbar';
import IntlMessages from '../../utility/IntlMessages';
import NotificationItem from './NotificationItem';
import {findNotifications} from 'services/NotificationService';
import {handleError} from 'utils/MessageUtils';
import {SYSTEM_AVATAR_URL} from 'shared/constants/AppConst';

const AppNotifications = () => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const [notifications, setNotifications] = useState([]);

  useSubscription('/topic/system-notifications', () => {
    loadData();
    notification['info']({
      message: intl.messages['common.notifications'],
      description: intl.messages['common.newNotification'],
    });
  });

  const loadData = () => {
    findNotifications(headers, {
      pagination: {
        current: 1,
        pageSize: 10,
      },
      filters: [
        {
          fields: 'type',
          value: 'USER',
        },
      ],
      sorters: [
        {
          field: 'createdDate',
          order: 'desc',
        },
      ],
    })
      .then((res) => {
        setNotifications(
          res.data.map((item) => {
            return {
              id: item.id,
              image: SYSTEM_AVATAR_URL,
              name: intl.messages['app.name'],
              message: item.content,
              time: item.createdDate,
            };
          }),
        );
      })
      .catch((error) => handleError(message, error));
  };

  useEffect(() => {
    loadData();
  }, []);

  const menu = (
    <Menu className='notify-header-message'>
      <Menu.Item className='header'>
        <IntlMessages id='common.notifications' /> ({notifications.length})
      </Menu.Item>
      <Menu.Item>
        <AppScrollbar className='notify-scroll-submenu'>
          <List
            className='notify-list'
            dataSource={notifications}
            renderItem={(item) => {
              return <NotificationItem key={item.id} item={item} />;
            }}
          />
        </AppScrollbar>
      </Menu.Item>
      <Menu.Item>
        <Button type='primary' className='notify-btn-all'>
          <IntlMessages id='common.viewAll' />
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} className='dropdown' trigger={['click']}>
      <a className='notify-link' onClick={(e) => e.preventDefault()}>
        <span className='notify-icon'>
          <IoIosNotificationsOutline />
        </span>
        <span className='notify-text'>
          <IntlMessages id='common.notifications' />
        </span>
      </a>
    </Dropdown>
  );
};

export default AppNotifications;
